import React from "react";

import "../../../../styles/css/App.css";

import { Grid } from "@material-ui/core";
import InfiniteScroll from 'react-infinite-scroller';
import CircularProgress from '@mui/material/CircularProgress';
import { Route, useRouteMatch, withRouter } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import UpdateRoundedIcon from '@mui/icons-material/UpdateRounded';
import FilterAltOffRoundedIcon from '@mui/icons-material/FilterAltOffRounded';
import * as Constants from "../../../../consts/Constants.js";

import alerter from "../../../alerts/alerter";
import EventItem from "./event-item"
import Pager from "../../../utils/pager";
import EventForm from "./event-form";

import service from '../../../../plas/services/shifter/service';

function Events({ history }) {

  let { path, url } = useRouteMatch();
  const isMedium = useMediaQuery({ query: `(max-width: 900px)` });

  const pager = React.useRef(new Pager(5));
  const firstTime = React.useRef(false);

  const timer = React.useRef();

  const [items, setItems] = React.useState([]);
  const [moreItems, setMoreItems] = React.useState(true);
  const [selectedState, setSelectedState] = React.useState(0);
  const [searchTerm, setSearchTerm] = React.useState(null)

  React.useEffect( () => () => {
    if (timer.current != null)
      clearInterval(timer.current);
    timer.current = null;
  }, [] );

  React.useEffect(() => {
    if (selectedState === 0) {
      if (timer.current == null)
        timer.current = setInterval(() => getNextPage(), 60000);
    } else {
      if (timer.current != null)
        clearInterval(timer.current);
      timer.current = null;
    }
  }, [selectedState]);

  React.useEffect(() => {
    let delayDebounceFn = null;
    if (firstTime.current) {
      delayDebounceFn = setTimeout(() => {
        resetSearch();
      }, 250)
    } else {
      firstTime.current = true
    }
    return () => {
      clearTimeout(delayDebounceFn)
    }
  }, [searchTerm])

  const ColoredLine = ({ color, marginTop, marginBottom }) => (
      <hr
        style={{
          color: color,
          backgroundColor: color,
          marginTop: marginTop !== undefined ? marginTop : 6,
          marginBottom: marginBottom !== undefined ? marginBottom : 16,
          height: 2
        }}
      />
  );

  const openEdit = (rowData) => {
    if (rowData !== undefined) {
      history.push(`${url}/${rowData.id}`);
    }
  }

  const goCalendar = (rowData) => {
    if (rowData !== undefined) {
      history.push(`${url}/${rowData.id}/shifts`);
    }
  }

  const close = () => {
    history.goBack()
  }

  const getNextPage = () => {

    let page = pager.current.getNextPage();
    let order = ["+name"];

    let startDate = null;
    let endDate = null;

    if (selectedState === 0) {
      var today = new Date();
      today.setHours(0,0,0,0);
      startDate = today.getTime();
    }


    service.api.events.getPage(page.startItem,page.endItem,startDate,endDate,searchTerm,order,(response) => {
      if (response.result != null) {
        pager.current.update(response.result.data.length, response.result.total)
        setMoreItems(!pager.current.ended);
        setItems([...items, ...response.result.data])
      } else {
        alerter.showError(response.error);
        setMoreItems(false);
      }
    });
  }

  const changeSearch = (e) => {
    let term = e.target.value.trim();
    if (!term)
      setSearchTerm(null);
    else
      setSearchTerm(term);  
  }

  const resetSearch = () => {
    pager.current.reset();
    setItems([]);
    setMoreItems(true);
  }

  const changeState = (newValue) => {
    if (newValue !== selectedState) {
      setSelectedState(newValue);
      resetSearch();
    }
  }

  const onChange = (event) => {
    let pos = -1;
    items.forEach((item, index) => {
      if (event.id === item.id) {
        pos = index;
      }
    });

    if (pos !== -1) {
      items[pos] = event;
    }

    setItems([...items]);
    close();
  }


  return (
    <div>
      <Grid container>
        <Grid item xs={false} md={2} />
        <Grid item xs={12} md={8} >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={12}>
                  <p style={{ fontSize: '28px', textAlign: 'left'}}>
                    Eventos
                  </p>
                </Grid>
              </Grid>
              <ColoredLine color="gray" marginTop={0} marginBottom={0} />
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={true} sm={6}>
                  <TextField 
                    label="Buscar" 
                    size="small" 
                    fullWidth 
                    variant="outlined" 
                    onChange={changeSearch}/>
                </Grid>
                <Grid item xs={false} sm={true}/>
                <Grid item>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="100%"> 
                    <Stack direction="row" spacing={1}>
                      <Chip color="default" icon={<UpdateRoundedIcon/>} label="Próximos" component="a" clickable variant={selectedState === 0 ? "filled" : "outlined" } onClick={() => changeState(0)}/>
                      <Chip color="default" icon={<FilterAltOffRoundedIcon/>} label="Todos" component="a" clickable variant={selectedState === -1 ? "filled" : "outlined" } onClick={() => changeState(-1)}/>
                    </Stack>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <div >
                <InfiniteScroll
                  pageStart={0}
                  loadMore={getNextPage}
                  hasMore={moreItems}
                  loader={<CircularProgress key={-1} size={32} style={{color:Constants.COLOR_PRIMARY, padding: 2}} color="inherit" />}>
                  {items.map((item, index) =>( 
                    <Grid key={item.id} container spacing={2}>
                      <Grid item xs={true}>
                        <EventItem key={index} event={item} onEdit={openEdit} onCalendar={goCalendar} />
                      </Grid>
                    </Grid>
                  ))}
                </InfiniteScroll>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={false} md={2} />
      </Grid>
       <Route exact path={`${path}/:eventId`}
          render={ (props) => 
            <Dialog
              maxWidth="lg" 
              fullScreen={isMedium}
              open={true}
              fullWidth={true}>
              <DialogContent style={{ paddingTop: 8, paddingBottom: 8 }}>
                <EventForm onCancel={close} fullWidth={true} eventId={props.match.params.eventId} onSave={onChange}/>
              </DialogContent>
            </Dialog>
          }
        />
    </div>
  );

}

export default withRouter(Events);
